<template>
  <div v-if="dataItems.length">
    <b-table
      responsive
      striped
      bordered
      :fields="dataFields"
      :items="dataItems"
      class="fraudReportHeaderTable"
    >
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    housePriceIndexData: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      dataFields: [
        {
          key: 'indexCol',
          label: '',
        },
        {
          key: 'qtrToqtrPercentage',
          label: 'Quarter to Quarter Percent (%) Change',
          tdClass: 'textTruncatee',thStyle: { width: '180px' }
        },
      ],
      dataItems: [],
      columnKeys: [
        'key1',
        'key2',
        'key3',
        'key4',
        'key5',
        'key6',
        'key7',
        'key8',
      ],
    }
  },
  computed: {
    hpiData() {
      return this.housePriceIndexData
    },
  },
  mounted() {
    if (this.hpiData && this.hpiData.hpiKeyValueResponseModels.length) {
      this.hpiData.hpiKeyValueResponseModels.forEach((item, index) => {
        this.dataFields.push({
          key: this.columnKeys[index],
          label: item.label,
          class: 'text-right',
        })
      })
      this.hpiData.hpiDataResponseModel.forEach((item, i) => {
        var count = 0
        this.dataItems.push({
          indexCol: item.geoAreaType,
          qtrToqtrPercentage: item.geoAreaValue,
        })
        this.hpiData.hpiKeyValueResponseModels.forEach((dataItem, index) => {
          this.dataItems[i][this.columnKeys[index]] = this.filterPtgData(item.dataPoints, count++)
        })
      })
    }
  },
  methods: {
    filterPtgData(value, i) {
      return value[i] ? value[i].smoothPctChange || '' : ''
    },
  },
}
</script>